import { DateTime } from 'luxon';

import { getFirstDayOfWeek } from 'src/common/date/getFirstDayOfWeek';

export function onNext(
  setSelectedDate: (date: DateTime) => void,
  assignmentDate: DateTime
): () => void {
  return () => {
    setSelectedDate(
      getFirstDayOfWeek(assignmentDate.plus({ weeks: 1 })).startOf('day')
    );
  };
}
